import Snackbar from "src/base-components/Snackbar";
import ReminderToast from "src/components/ReminderToast";
import GlobalReminderModals from "src/components/GlobalReminderModals";
import NotificationPermissionModal from "src/components/NotificationPermissionModal";
import Router from "./router";
import { useCallback, useEffect } from "react";
import { useAppSelector } from "./stores";
import { selectAuthUser } from "./stores/auth";
import { appInitializer } from "./helpers";
// import { usePushNotification } from "./firebase";
import runOneSignal, { usePushNotification } from "./onesignal";
import CallsLogsModal from "./components/CallsLogsModal";
import { checkAndPromptForNotificationPermissions } from "./utils/notificationPermissionUtils";

const AppContent = () => {
  const pushNotification = usePushNotification();
  const authUser = useAppSelector(selectAuthUser);

  useEffect(() => {
    const initializeApp = async () => {
      // Initialize OneSignal first
      await runOneSignal();

      // Check device token availability and show modal if needed
      // Only check if user is logged in
      if (authUser?.token) {
        setTimeout(() => {
          checkAndPromptForNotificationPermissions();
        }, 2000); // Small delay to ensure UI is ready
      }

      appInitializer(authUser);
    };

    // Listen for manual trigger to show notification permission modal
    const handleShowModal = () => {
      checkAndPromptForNotificationPermissions();
    };

    window.addEventListener(
      "show-notification-permission-modal",
      handleShowModal
    );

    initializeApp();
    pushNotification;

    // Expose a dev helper to trigger the reminder toast from console
    try {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      window.showReminderToastForDebug = (payload: any) =>
        window.dispatchEvent(
          new CustomEvent("show-reminder-toast", { detail: payload })
        );

      // Expose helper to manually trigger notification permission modal
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      window.showNotificationPermissionModal = () =>
        window.dispatchEvent(
          new CustomEvent("show-notification-permission-modal")
        );
    } catch (err) {
      // ignore
    }

    // Cleanup event listener
    return () => {
      window.removeEventListener(
        "show-notification-permission-modal",
        handleShowModal
      );
    };
  }, [authUser?.token]); // Add authUser.token as dependency

  const RouterCallback = useCallback(
    () => <Router />,
    [authUser?.role?.permissions?.length]
  );

  return (
    <>
      <Snackbar />
      <ReminderToast />
      <CallsLogsModal />
      <GlobalReminderModals />
      <NotificationPermissionModal />
      <RouterCallback />
    </>
  );
};
export default AppContent;
